// extracted by mini-css-extract-plugin
export var container = "cardInfoTable-module--container--3TFN9";
export var title = "cardInfoTable-module--title--1pytT";
export var detail = "cardInfoTable-module--detail--2w_L3";